import FormSection from '@/components/Forms/FormSection';
import { Box } from '@palmetto/palmetto-components';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { Link } from 'react-router-dom';

import {
  HVACInstallPackageFileCategory,
  InstallationPackagePhotoCategory,
  ProgramType,
  RequirementFlagSettingsType,
} from 'types';

import { PhotosList } from '../Documents/PhotosList';

type InstallPhotosProps = {
  allowArchive?: boolean;
  showCheckboxes: boolean;
  checkboxCategories: HVACInstallPackageFileCategory[];
  isPackageEditable?: boolean;
};

export const InstallPhotos = ({
  allowArchive,
  showCheckboxes,
  checkboxCategories,
  isPackageEditable = true,
}: InstallPhotosProps) => {
  const { installPhotosForHvac } = useFlags();

  if (!installPhotosForHvac) {
    return null;
  }

  return (
    <FormSection
      title="All Installation Documentation"
      description={
        <Box gap="sm" fontSize="xs">
          <Box>
            Upload all documents and photos collected during the new system installation. These typically include a
            Load Calculation, Install Commissioning Document(s), and New System Photos.
          </Box>
          <Box display="block">
            For a full list of requirements,{' '}
            <Link
              to={'https://hep.palmetto.finance/en/articles/10092141-hep-installation-requirements'}
              target="_blank"
            >
              check the Knowledge Base.
            </Link>
          </Box>
        </Box>
      }
    >
      <PhotosList
        title="Uploaded Install Documentation"
        baseCategory={'Install Photos'}
        allowArchive={allowArchive}
        category={InstallationPackagePhotoCategory.hvacInstallationPhotos}
        flagType={RequirementFlagSettingsType.hvacInstallationPhotos}
        showCheckboxes={showCheckboxes}
        checkboxCategories={checkboxCategories}
        programType={ProgramType.hvac}
        isPackageEditable={isPackageEditable}
      />
    </FormSection>
  );
};
